import Bloodhound from 'corejs-typeahead/dist/bloodhound.js';

const CATEGORY_KEY = 'nal-categories-boost';
const CACHE_KEY = 'nal-categories-boost-cache';

const route = window.nal?.project === 'outlook' ? '/api/outlook/categories' : '/api/categories';

const locationsBloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value', 'matches', 'nameSearchable'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    identify: (obj) => (obj.value),
    limit: 10,
    remote: {
        url: route + '/locations?query=%QUERY',
        prepare: function (query, settings) {
            settings.url = settings.url.replace('%QUERY', encodeURIComponent(query));
            return window.jwt.addHeaderToSettings(settings);
        },
    },
});
const companiesBloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    limit: 10,
    remote: {
        url: route + '/companies?query=%QUERY',
        prepare: function (query, settings) {
            settings.url = settings.url.replace('%QUERY', encodeURIComponent(query));
            return window.jwt.addHeaderToSettings(settings);
        },
    },
});

function getCategoryStore() {
    if (!window.nal.categories) {
        window.setVueObject(window.nal, 'categories', {});
    }

    return window.nal.categories;
}

function initializeCategoryDefaults(categoryStore = getCategoryStore()) {
    categoryStore.locations = locationsBloodhound;
    categoryStore.companies = companiesBloodhound;

    return categoryStore;
}

function isCategoryPayload(data) {
    return !!data && typeof data === 'object';
}

const updateCategories = (data, includeNalCategories = true, categoryStore = getCategoryStore()) => {
    if (!isCategoryPayload(data)) {
        catchLoadCategoriesError({
            message: 'Categories response was empty',
            extra: { data },
        });
        return;
    }

    initializeCategoryDefaults(categoryStore);

    categoryStore.careers = data.careers;
    categoryStore.industries = data.industries;
    categoryStore.classifications = data.classifications;
    categoryStore.types = data.companyTypes;
    categoryStore.languages = data.languages;
    categoryStore.sizes = data.teamSizes;
    categoryStore.locations.clear();
    categoryStore.locations.add(data.countries);

    if (includeNalCategories) {
        categoryStore.nalIndustries = data.nalIndustries;
        categoryStore.nalCareers = data.nalCareers;
        categoryStore.functions = data.areas;
    }
};

async function loadCategories() {
    const categoryStore = initializeCategoryDefaults();
    categoryStore.locations.initialize();
    categoryStore.companies.initialize();
    let cache;
    
    try {
        cache = localStorage?.getItem(CACHE_KEY);
    } catch {
        // eslint-disable-next-line no-console
        console.error('Error reading cache from localStorage');
    }
    const categories = [
        'careers',
        'industries',
        'nalIndustries',
        'nalCareers',
        'areas',
        'classifications',
        'companyTypes',
        'languages',
        'teamSizes',
        'countries',
    ];
    let localStorageData;
    try {
        const data = localStorage?.getItem(CATEGORY_KEY);
        localStorageData = data ? JSON.parse(data) : null;
    } catch {
        localStorageData = null;
    }
    if (localStorageData && cache === window.nal.categoriesCache && isCategoryPayload(localStorageData)) {
        const undefinedCategories = categories.filter(
            (category) => !localStorageData[category]?.length
        );
        if (undefinedCategories.length === 0) {
            updateCategories(localStorageData);
            return;
        }
    }
    window.jwt.handleOutlookRequest();
    try {
        const data = await $.ajax({ url: route });
        updateCategories(data);
        try {
            localStorage?.setItem(CATEGORY_KEY, JSON.stringify(data));
            localStorage?.setItem(CACHE_KEY, window.nal.categoriesCache);
        } catch {
            localStorage?.removeItem(CATEGORY_KEY);
            localStorage?.removeItem(CACHE_KEY);
        }
    } catch (error) {
        if (![401, 0, 502].includes(error.status)) {
            catchLoadCategoriesError(error);
        }
    }
}

function catchLoadCategoriesError(error) {
    window.notify(trans('nal-lang.error.error-detected'), 'alert');
    if (window.Sentry) {
        window.Sentry.captureMessage(error?.message || 'Failed to load categories', {
            extra: { error, route },
        });
    }
}

export { loadCategories, locationsBloodhound, companiesBloodhound, updateCategories };
